var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { SchemaItemType } from "@@/Schema";
import { action, makeObservable, observable } from "mobx";
export class RemoteRowBuilderState {
    constructor() {
        this.show = false;
        this.zindex = 0;
        this.top = 0;
        this.left = 0;
        this.dragging = false;
        this.rid = "";
        this.adding = false;
        this.selecteditemtype = SchemaItemType.Remote;
        makeObservable(this);
    }
    setSelectedItemType(type) {
        this.selecteditemtype = type;
    }
    setAdding(adding) {
        this.adding = adding;
    }
    setRemoteId(id) {
        this.rid = id;
    }
    setZIndex(index) {
        this.zindex = index;
    }
    setDragging(drag) {
        this.dragging = drag;
    }
    setTop(top) {
        this.top = top;
    }
    setLeft(left) {
        this.left = left;
    }
    setShow(show) {
        this.show = show;
    }
    reset() {
        this.setDragging(false);
        this.setRemoteId("");
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], RemoteRowBuilderState.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RemoteRowBuilderState.prototype, "zindex", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RemoteRowBuilderState.prototype, "top", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RemoteRowBuilderState.prototype, "left", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RemoteRowBuilderState.prototype, "dragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RemoteRowBuilderState.prototype, "rid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RemoteRowBuilderState.prototype, "adding", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], RemoteRowBuilderState.prototype, "selecteditemtype", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RemoteRowBuilderState.prototype, "setSelectedItemType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RemoteRowBuilderState.prototype, "setAdding", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RemoteRowBuilderState.prototype, "setRemoteId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RemoteRowBuilderState.prototype, "setZIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RemoteRowBuilderState.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RemoteRowBuilderState.prototype, "setTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RemoteRowBuilderState.prototype, "setLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RemoteRowBuilderState.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RemoteRowBuilderState.prototype, "reset", null);
